import { useEffect } from 'react';
import { posthog } from 'posthog-js';
import { usePosthogDistinctId } from './usePosthogDistinctId';

export interface User {
  id: string;
  email?: string;
  provider?: string;
  accessToken?: string;
}

export const usePosthogIdentify = (user: User | null) => {
  const { distinctId, aliasUser } = usePosthogDistinctId();

  useEffect(() => {
    if (user?.id) {
      // Create an alias between anonymous ID and user ID
      aliasUser(user.id);

      // Identify the user in PostHog
      posthog.identify(user.id, {
        email: user.email,
        provider: user.provider,
        $set: {
          // Set these properties once
          first_seen: new Date().toISOString(),
        },
        $set_once: {
          // Update these properties on every identify call
          last_seen: new Date().toISOString(),
          auth_provider: user.provider,
        },
      });
    } else {
      // Reset user identification when logged out
      posthog.reset();

      // Log the anonymous ID for debugging
      console.log('[PostHog] Reset to anonymous ID:', distinctId);
    }
  }, [user]);
};

export default usePosthogIdentify;
